import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import ChangedValueIndicator from './_changed-value-indicator.js'

export default {
  name: 'PartView',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    selectionName: {
      configSet: Text,
      configValues: {},
    },
    marketName: {
      configSet: Text,
      configValues: {},
    },
    changedMarketIndicator: {
      configSet: ChangedValueIndicator,
      configValues: {
        container: {
          style: {
            flexDirection: 'row-reverse',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
